import React from 'react'
import { AGE_RANGE_FILTER_FEATURE_ENTRY_POINT_BANNER_IMAGES } from '@moonpig/web-core-brand/config'
import { RangeFilterEntryPointBanner } from '../../RangeFilterEntryPointBanner'
import { useFindLocaleText } from '../../../text-localisation'

export const AgeRangeFilterBanner = () => {
  const localiseText = useFindLocaleText()

  return (
    <RangeFilterEntryPointBanner
      title={localiseText('find.age_range_filter_banner.heading')}
      description={localiseText('find.age_range_filter_banner.description')}
      images={{
        xs: AGE_RANGE_FILTER_FEATURE_ENTRY_POINT_BANNER_IMAGES.xs,
        md: AGE_RANGE_FILTER_FEATURE_ENTRY_POINT_BANNER_IMAGES.md,
        description: localiseText('find.age_range_filter_banner.description'),
      }}
      ctaTitle={localiseText('find.age_range_filter_banner.cta_title')}
      filterId="birthday-milestones"
      data-testid="age-range-filter-banner"
    />
  )
}
